export default __webpack_public_path__ + "static/media/PSPC-DT-high-level.b7eed5a6.png";